import { reviews } from "@/mocks/guatrend";

function Stars({ n }: { n: number }) {
  return (
    <span className="flex items-center gap-0.5 text-accent-500">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={i < n ? "ri-star-fill text-sm" : "ri-star-line text-sm text-foreground-300"}></i>
      ))}
    </span>
  );
}

export default function ReviewSection() {
  return (
    <section id="review" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium text-accent-500">WORD OF MOUTH</p>
          <h2 className="font-display mt-2 text-2xl text-foreground-900 md:text-4xl">网友怎么说，口碑最诚实</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            58万+ 真实网友点评沉淀出的高分合集，听听吃瓜人的真实心声。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-6"
            >
              <span className="text-4xl leading-none text-primary-300">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                {r.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 font-display text-background-50">
                  {r.name.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
                <span className="ml-auto">
                  <Stars n={r.score} />
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}